<template>
  <div>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th></th>
          <th>Produto</th>
          <th>Quantidade</th>
          <th>Valor unitário</th>
          <th>ICMS</th>
          <th>IPI</th>
          <th>Total</th>
          <th class="text-center"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="produto in carrinho.produtos" :key="produto.id">
          <td>
            <v-checkbox
              dense
              v-model="produto.$$selecionado"
            ></v-checkbox>
          </td>
          <td>
            <px-span-tooltip
              v-if="checkCodigo(produto.respostaCotacaoProduto.cotacaoProduto.produto)"
              top
              :text="labelCodigo(produto.respostaCotacaoProduto.cotacaoProduto.produto)"
              tooltip="Código interno"/>
            <px-span-tooltip top
                             :text="labelDescricao(produto.respostaCotacaoProduto
                            .cotacaoProduto.produto)"
                             :tooltip="produto.respostaCotacaoProduto
                            .cotacaoProduto.produto.descricao"/>
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.cotacaoProduto.quantidade
                | number(getCurrencyFormat(produto.respostaCotacaoProduto
                .cotacaoProduto.produto.casasDecimais))
            }}
            {{ produto.respostaCotacaoProduto.cotacaoProduto.unidadeMedida.descricao }}
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.precoUnitario
                | currency(simboloMoeda, produto.respostaCotacaoProduto
                .cotacaoProduto.produto.casasDecimais, configuracaoFormatacaoMoeda)
            }}
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.impostos.valorIcms
                | currency(simboloMoeda, produto.respostaCotacaoProduto
                .cotacaoProduto.produto.casasDecimais, configuracaoFormatacaoMoeda)
            }}
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.impostos.valorIpi
                | currency(simboloMoeda, produto.respostaCotacaoProduto
                .cotacaoProduto.produto.casasDecimais, configuracaoFormatacaoMoeda)
            }}
          </td>
          <td>
            {{
              produto.respostaCotacaoProduto.total
                | currency(simboloMoeda, produto.respostaCotacaoProduto
                .cotacaoProduto.produto.casasDecimais, configuracaoFormatacaoMoeda)
            }}
          </td>
          <td>
            <v-tooltip top v-if="!disableActions && hasModuleGerencia">
              <template v-slot:activator="{ on }">
                    <span v-on="on">
                         <v-btn icon small @click="removerProduto(produto.id)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </span>
              </template>
              <span>Remover produto do carrinho</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';
import { mapGetters } from 'vuex';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  name: 'ListagemCarrinhoProdutos',
  props: {
    carrinho: {
      type: Object,
      required: true,
    },
    disableActions: {
      default: false,
    },
    removerProduto: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'respostaCotacaoProduto.cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    moeda() {
      return this.carrinho.respostaCotacao.moeda;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
    labelDescricao() {
      return item => Vue.filter('truncate')(item.descricao, 30);
    },
  },
  created() {
    this.carrinho.produtos = this.carrinho.produtos.map(produto => ({
      ...produto,
      $$selecionado: true,
    }));
  },
};
</script>
